var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0486 4.04876V6.77232H5.95111V4.04876C5.95111 2.91726 6.86837 2 7.99988 2C9.13138 2 10.0486 2.91726 10.0486 4.04876ZM3.95111 4.04876C3.95111 1.81269 5.76381 0 7.99988 0C10.2359 0 12.0486 1.81269 12.0486 4.04876V6.77232V7.42274H13.5428C14.6103 7.42274 15.4897 8.26123 15.5405 9.32761L15.9978 18.9314C16.0521 20.0721 15.142 21.0266 14.0001 21.0266H2.00005C0.858129 21.0266 -0.0520048 20.0721 0.00231083 18.9314L0.459637 9.32761C0.510416 8.26123 1.38979 7.42274 2.45737 7.42274H3.95111V6.77232V4.04876ZM2.45737 9.42274H13.5428L14.0001 19.0266H2.00005L2.45737 9.42274Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.608a84adbfff19afca0b2331c407908e.svg";
export { ForwardRef as ReactComponent };